/**
 * Which country's content a learner sees (US or IN).
 * Order: manual choice > payment country > signup country > India.
 */
export type ContentCountry = "US" | "IN";

export function resolveContentCountry(p: {
  content_country?: string | null;
  content_country_source?: string | null;
  country?: string | null;
  country_code?: string | null;
} | null | undefined): ContentCountry {
  const norm = (v?: string | null): ContentCountry | null => {
    const s = (v ?? "").trim().toUpperCase();
    if (["US", "USA", "UNITED STATES", "UNITED STATES OF AMERICA"].includes(s)) return "US";
    if (["IN", "IND", "INDIA"].includes(s)) return "IN";
    return null;
  };
  return norm(p?.content_country) ?? norm(p?.country_code) ?? norm(p?.country) ?? "IN";
}

/** Payer country → content country. Only US and India carry packs today. */
export function countryFromPayment(provider: "paypal" | "razorpay", payerCountry?: string | null): ContentCountry | null {
  if (provider === "razorpay") return "IN";
  const c = (payerCountry ?? "").toUpperCase();
  return c === "US" ? "US" : c === "IN" ? "IN" : null;
}

export const COUNTRY_LABEL: Record<ContentCountry, string> = { US: "United States", IN: "India" };
